<mat-card class="table-container mat-elevation-z8">
  <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px;">
    <h4>
      View and edit resources.
      <br> Upload Manuals.
    </h4>
    <div style="display: flex; gap: 8px;">
      <button mat-button class="custom-switch-button" (click)="exportToCSV()">
        <mat-icon>table_view</mat-icon>
        EXPORT TO CSV
      </button>
      <button mat-button class="custom-switch-button" (click)="exportToPDF()">
        <mat-icon>description</mat-icon>
        EXPORT TO PDF
      </button>
      <button mat-button class="custom-switch-button" (click)="openBulkUploadDialog()">
        <mat-icon>cloud_upload</mat-icon>
        BULK UPLOADS
      </button>
    </div>
  </div>

  <div class="filter-container" style="display: flex; gap: 16px; flex-wrap: wrap; margin-bottom: 16px;">
    <mat-form-field class="small-rounded-filter" appearance="outline" style="min-width: 250px;">
      <mat-label>Make</mat-label>
      <mat-select [(ngModel)]="filters.make" (selectionChange)="onMakeChange()" multiple>
        <mat-option>
          <ngx-mat-select-search
            [formControl]="makeFilterCtrl"
            placeholderLabel="Search Make..."
            noEntriesFoundLabel="No matching Make found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let make of getFilteredMakes()" [value]="make">
          {{ make }}
        </mat-option> 
      </mat-select>
    </mat-form-field>

    <ng-container *ngIf="filters.make.length > 0">
      <mat-form-field class="small-rounded-filter" appearance="outline" style="min-width: 300px;">
        <mat-label>Model</mat-label>
        <mat-select [(ngModel)]="filters.model" (selectionChange)="applyFilters()" multiple>
          <mat-option>
            <ngx-mat-select-search
              [formControl]="modelFilterCtrl"
              placeholderLabel="Search Model..."
              noEntriesFoundLabel="No matching Model found">
            </ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let model of getFilteredModels()" [value]="model">
            {{ model }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <button mat-raised-button (click)="clearAllFilters()" class="clear-button">Clear Filters</button>
    </ng-container>
  </div>
  <h4>Search results:</h4>
  <div class="table-responsive">
    <table mat-table [dataSource]="dataSource || []" matSort class="full-width-table">
      <ng-container matColumnDef="make">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-cell">Make</th>
      <td mat-cell *matCellDef="let element">{{ element.make }}</td>
      </ng-container>

      <ng-container matColumnDef="model">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-cell">Model</th>
      <td mat-cell *matCellDef="let element">{{ element.model }}</td>
      </ng-container>

      <ng-container matColumnDef="oec">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-cell">OEC</th>
      <td mat-cell *matCellDef="let element">{{ element.oec }}</td>
      </ng-container>

      <ng-container matColumnDef="resources">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-cell">Resources</th>
        <td mat-cell *matCellDef="let element">{{ element.resources }}</td>
      </ng-container>

      <ng-container matColumnDef="expandRecord">
        <th mat-header-cell *matHeaderCellDef class="header-cell">Actions</th>
        <td mat-cell *matCellDef="let element">
          <button
            mat-raised-button
            color="primary"
            class="expand-record-button"
            (click)="openEquipmentRecordModal(element)">
            <mat-icon>visibility</mat-icon>
            EXPAND RECORD
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  <div *ngIf="isLoading" class="loading-container">
    <div style="position: fixed; top: 42%; left: 50%; transform: translate(-50%, -50%); display: flex; flex-direction: column; align-items: center;">
      <mat-spinner color="primary"></mat-spinner>
    </div>
  </div>
  <div *ngIf="!isLoading && (!dataSource.data || dataSource.data.length === 0)" class="no-data-container">
    <img src="assets/no_entry_found.png" alt="No entry found" class="no-entry-icon">
    <p>Data not found! Please select Make</p>
  </div>
  <mat-paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons></mat-paginator>
</mat-card>